import {createRoot, hydrateRoot} from 'react-dom/client';
import FreeFranceDirectory from '../pages/FreeFranceDirectory/FreeFranceDirectory'
import "../index.css";
import "../pages/FreeFranceDirectory/FreeFranceDirectory.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<FreeFranceDirectory {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <FreeFranceDirectory {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).FreeFranceDirectoryVC = {mount, hydrate, unmount}